import { Checkbox as ChakraCheckbox, CheckboxProps, ComponentWithAs } from '@chakra-ui/react'
import { withShade } from './utils'

export const Checkbox = withShade(ChakraCheckbox as ComponentWithAs<'input', CheckboxProps>)
